import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TrophyOutlinedSvg from "@ant-design/icons-svg/es/asn/TrophyOutlined";
import AntdIcon from "../components/AntdIcon";
var TrophyOutlined = function TrophyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrophyOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TrophyOutlined.displayName = 'TrophyOutlined';
}
export default /*#__PURE__*/React.forwardRef(TrophyOutlined);